const Questions = () => {
  return(
    <div style={{margin:"300px"}}>
      <h1>Q&A</h1>
      <h3>work in progress</h3>
    </div>
  );
};

export default Questions;